import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    GetDisclosureHistoryDetailDTO,
} from '@/services/ai-disclosure/service/ai-disclosure.repository.interface';
import { GetHistoryDetail } from '@/infrastructure/api-functions/interface/get-history-detail.interface';
import type { HistoryDetail } from '@/services/history/type/history.type';

const NO_PERMISSION_ERROR_CODE = 11120120;

@injectable()
export class GetDisclosureHistoryDetailDTOImpl implements GetDisclosureHistoryDetailDTO {
    constructor(
        @inject(GetHistoryDetail)
        private readonly _getHistoryDetailApi: GetHistoryDetail
    ) {
    }

    async fetch(taskId: string): Promise<HistoryDetail> {
        try {
            const res = await this._getHistoryDetailApi.getHistoryDetail(taskId);
            const detail = res.detail || {};
            const {
                title = '',
                input = '',
                setting = {},
                hidden = [],
                generated_paragraphs,
                // tech_field：生成技术领域| background：生成背景技术描述 | reference：生成引用文献介绍 | drawbacks：生成现有技术的缺点 | tech_problem：生成发明目的的问题描述 | tech_effect：生成发明目的的有益效果 | tech_means：生成技术方案 | embodiment：生成实施例
                tech_field = '',
                background = '',
                reference = '',
                drawbacks = '',
                tech_problem = '',
                tech_effect = '',
                tech_means = '',
                embodiment = '',
            } = detail;

            const generatedParagraphs = generated_paragraphs || [];

            return {
                historyTitle: res.title,
                input,
                currentStep: detail.current_step,
                title,
                settings: {
                    inventionSubject: setting.invention_subject || [],
                    recommendInventionSubject: setting.recommend_invention_subject || [],
                    applicationField: setting.application_field || [],
                    recommendApplicationField: setting.recommend_application_field || [],
                    other: setting.other || '',
                    techMeans: setting.tech_means || '',
                    techEffect: setting.tech_effect || '',
                },
                hidden,
                disclosureResult: [{
                    paragraphType: 'tech_field',
                    content: tech_field,
                    isGenerated: generatedParagraphs.includes('tech_field'),
                }, {
                    paragraphType: 'background',
                    content: background,
                    isGenerated: generatedParagraphs.includes('background'),
                }, {
                    paragraphType: 'reference',
                    content: reference,
                    isGenerated: generatedParagraphs.includes('reference'),
                }, {
                    paragraphType: 'drawbacks',
                    content: drawbacks,
                    isGenerated: generatedParagraphs.includes('drawbacks'),
                }, {
                    paragraphType: 'tech_problem',
                    content: tech_problem,
                    isGenerated: generatedParagraphs.includes('tech_problem'),
                }, {
                    paragraphType: 'tech_effect',
                    content: tech_effect,
                    isGenerated: generatedParagraphs.includes('tech_effect'),
                }, {
                    paragraphType: 'tech_means',
                    content: tech_means,
                    isGenerated: generatedParagraphs.includes('tech_means'),
                }, {
                    paragraphType: 'embodiment',
                    content: embodiment,
                    isGenerated: generatedParagraphs.includes('embodiment'),
                }],
            };
        } catch (err) {
            if (err.cause?._error_code === NO_PERMISSION_ERROR_CODE) {
                throw new Error('NO_PERMISSION');
            }
        }
    }
}
